var map = {
	"./Dietery_Supplements2.webp": 1349,
	"./Hormone_Therapy2.webp": 6870,
	"./IMG_0440.webp": 5612,
	"./IV_Therapy2.webp": 672,
	"./Skin_Peel2.webp": 4533,
	"./Slide-1-2.webp": 3274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4347;